import { useLayoutEffect } from "react";
import { getConsumerWebsiteOrigin } from "../utils/consumerWebsiteOrigin.js";

/** Sends users from admin `/event?...` to the public consumer site's event booking page. */
export default function EventBookingRedirect() {
  useLayoutEffect(() => {
    const base = getConsumerWebsiteOrigin();
    const search = window.location.search || "";
    window.location.replace(`${base}/event${search}`);
  }, []);

  return null;
}
